// Dismissable alert banner. Replaces 5+ copies of the same JSX across pages.
//
//   <MessageBanner msg={msg} onDismiss={() => setMsg(null)} />
//
// ``msg`` is ``{ type: 'success' | 'error' | 'info', text: string }`` or null.
export function MessageBanner({ msg, onDismiss }) {
  if (!msg) return null;
  const cls =
    msg.type === 'error' ? 'alert-error' : msg.type === 'info' ? 'alert-info' : 'alert-success';
  return (
    <div className={`alert ${cls}`}>
      {msg.text}
      {onDismiss && (
        <button
          onClick={onDismiss}
          style={{ float: 'right', background: 'none', border: 'none', cursor: 'pointer' }}
          aria-label="Dismiss"
        >
          x
        </button>
      )}
    </div>
  );
}
